import * as React from 'react';

import {Carousel} from 'antd';

import { addSubtitlesToYoutubeVideos } from '@app/components/LocalCommon/Utils/VideoExtensions';

import '@app/scss/components/videoEmbed.scss';

interface VideoEmbedProps {
	videoText: string | JSX.Element;
	videoSrc?: string[];
	videoTitle?: string;
}
const arrowIcon = require('@app/images/arrow_circle.svg');

const VideoEmbedSlider: React.FC<VideoEmbedProps> = ({videoText, videoSrc, videoTitle}) => {
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const slider = React.useRef<any>();
	return (
		<section className={`video-embed ${videoSrc ? 'video-embed_with-video' : ''}`}>
			<div className="video-embed__text">{videoText}</div>
			{videoSrc && (
				<div className="video-embed-block">
					<Carousel
						ref={slider}
						afterChange={setCurrentIndex}
						// dots={true}
						// slidesToShow={1}
						infinite
					>
						{
							videoSrc.map((item, index) => (
								<iframe
									key={index}
									className="video-embed-block__video"
									src={addSubtitlesToYoutubeVideos(item)}
									width="696"
									height="392"
									frameBorder="0"
									allow="autoplay; fullscreen"
									allowFullScreen

								/>
							))
						}
					</Carousel>
					{videoTitle && <p className="video-embed-block__title">{videoTitle}</p>}
					<div className="slider-tes-buttons">
						<img
							className="slider-tes-button slider-tes-button_left"
							src={arrowIcon}
							alt="Prev"
							onClick={() => slider.current!.prev()}
						/>
						<img
							className="slider-tes-button"
							src={arrowIcon}
							alt="Next"
							onClick={() => slider.current!.next()}
						/>
					</div>
				</div>
			)}

		</section>
	);
};

export default VideoEmbedSlider;
